//let url = "https://" + window.location.host + "/moslcms/cms/";
let url = process.env.REACT_APP_BASE_URL;
let baseAPI = process.env.REACT_APP_BASE_URL + '/';
//let baseAPI = 'http://localhost:8080/api/v1/';
//let baseAPI = 'http://dxtechsol.com:8085/api/v1/';
console.log(url, '<--urlEndpoint-->', baseAPI)
export const endpoints = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    app: {
        init: `/init`
    },
    user: {
        getUser: '/users'
    },
    login: {
        generateOtp: '/login/generateOtp',
        verifyOtp: '/login/authenticateUser',
        logout: '/login/logout',
        common: `${baseAPI}login/common`,
        logout: '/logout',
        SETMPIN: "/c/login/SETMPIN",
        GenrateMPINOTPValidate: '/c/login/GenrateMPINOTPValidate'
    },
    additionalPurchase: {
        getFolioList: '/additionalPurchase/folioList',
    },
    preLogin: {
        internationalBusiness: `${baseAPI}getIntBusiness`,
        aboutUs: `${baseAPI}Aboutus`,
        faq: `${baseAPI}getFAQ`,
        NavDetail: `${baseAPI}NAVDetails`,
        HistoricalFilter: `${baseAPI}HistoricalFilter`,
        MFHome: `${baseAPI}MFHome`,
        passiveHome: `${baseAPI}PassiveFundHome`,
        fundDetail: `${baseAPI}FundDetail`,
        FundCategory: `${baseAPI}FundCategory`,
        FundCategoryNew: `${baseAPI}FundCategoryNew`,
        STPCategory: `${baseAPI}SchemesForSTP`,
        GetFundsForFilter: `${baseAPI}GetFundsForFilter`,
        CompareFunds: `${baseAPI}CompareFunds`,
        download: `${baseAPI}getDownloads`,
        SearchDownloads: `${baseAPI}SearchDownloads`,
        ContactUs: `${baseAPI}ContactUs`,
        enquiry: `${baseAPI}enquiry`,
        perforamceGraph: `${baseAPI}PerformanceGraph`,
        perforamceGraphNew: `${baseAPI}PerformanceGraphNew`,
        PMSCategory: `${baseAPI}PMSFundCategory`,
        PMSFundDetail: `${baseAPI}PMSFundDetail`,
    },
    ob: {
        masters: `${baseAPI}ob/getMasters`,
        common: `${baseAPI}ob/common`,
        ifscBankDet: `${baseAPI}ob/getBankFromIFSC`
    },
    trans: {
        common: `${baseAPI}trans/common`,
        commonGet: `${baseAPI}trans/commonGet`,
    },
    extra: {
        GetSchemeDetForSIPDashboard: `${baseAPI}/GetSchemeDetForSIPDashboard`,
        getSchemeName: `${baseAPI}/getSchemeName`,
    },
    aif: {
        SaveAIFTransData: `${baseAPI}SaveAIFTransData`,
        GetAIFUserDetails: `${baseAPI}GetAIFUserDetails`,
        step1: `${baseAPI}step1`,
        step3: `${baseAPI}step3Adv`,
        getDocumentStatus: `${baseAPI}getDocumentStatus`,
        notifyUser: `${baseAPI}notifyUser`,
    },
    cart: {
        getAIFDetails: `/getAIFDetails`,
        getBankDetails: "/getBankDetails",
        saveTransaction: '/saveTransaction',
        confirmTransaction: '/confirmTransaction'
    },
    checkCookies: `${baseAPI}chklogin`,
    GetEmandateDetails: '/GetEmandateDetails',
    SaveEmandateToken: '/SaveEmandateToken',
    SaveEmandateResponse: '/SaveEmandateResponse',
    GetAIFMOH: '/GetAIFMOH',
    logout: {
        removeCookie: '/removeCookie'
    }
}